import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header";

const addAchAccount = ({
    party,
    account_name,
    aba_transit_number,
    account_number,
    end_date,
    authorization_received,
    one_time_use_only,
    active_yn,
    is_default
}) => {
    return axios.post(
        API + "parties/api/ach-accounts/create/",
        {
            party,
            account_name,
            aba_transit_number,
            account_number,
            end_date,
            authorization_received,
            one_time_use_only,
            active_yn,
            is_default
        },
        { headers: authHeader()}
    );
};

const editAchAccount = (
  id,
  {
    party,
    account_name,
    aba_transit_number,
    account_number,
    end_date,
    authorization_received,
    one_time_use_only,
    active_yn,
    is_default
  }
) => {
  return axios.post(
    API + `parties/api/ach-accounts/${id}/update/`,
    {
      party,
      account_name,
      aba_transit_number,
      account_number,
      end_date,
      authorization_received,
      one_time_use_only,
      active_yn,
      is_default
    },
    { headers: authHeader() }
  );
};


const getAchAccount = (id) => {
  return axios.get(`${API}parties/api/ach-accounts/${id}/`, {
 
    headers: authHeader(),
    // cache: "no-store",
  })
};


const viewAchAccounts = () => {
  return axios.get(API + "parties/api/ach-accounts/", { headers: authHeader() });
};

const ACHaccountsServices = {
  addAchAccount,
  editAchAccount,
  getAchAccount,
  viewAchAccounts,
};

export default ACHaccountsServices;